import showIcon from "../assets/icons/ico-Shows.png"
import advIcon from "../assets/icons/ico-adv.png"
import bannersIcon from "../assets/icons/ico-banners.png"
import bookIcon from "../assets/icons/ico-books.png"
import identityIcon from "../assets/icons/ico-identity.png"
import libIcon from "../assets/icons/ico-lib.png"
import packageIcon from "../assets/icons/ico-package.png"
import photoIcon from "../assets/icons/ico-photo.png"
import profileIcon from "../assets/icons/ico-profile.png"
import socialIcon from "../assets/icons/ico-social.png"
import webIcon from "../assets/icons/ico-web.png"
// import wasaelIcon from "../assets/icons/ico-wasael.png"

// New WebP imports
import showImg from "../assets/sliderImages/servShows-img.webp"
import advImg from "../assets/sliderImages/servAdv-img.webp"
import bannersImg from "../assets/sliderImages/servBanner-img.webp"
import bookImg from "../assets/sliderImages/servBooks-img.webp"
import identityImg from "../assets/sliderImages/servIdentity-img.webp"
import libImg from "../assets/sliderImages/servLib-img.webp"
import packageImg from "../assets/sliderImages/servPackage-img.webp"
import photoImg from "../assets/sliderImages/servPhoto-img.webp"
import profileImg from "../assets/sliderImages/servProfile-img.webp"
import socialImg from "../assets/sliderImages/servSocial-img.webp"
import webImg from "../assets/sliderImages/servWeb-img.webp"

// old JPG imports
// import showImg from "../assets/images/servShows-img.jpg"
// import advImg from "../assets/images/servAdv-img.jpg"
// import bannersImg from "../assets/images/servBanner-img.jpg"
// import bookImg from "../assets/images/servBooks-img.jpg"
// import identityImg from "../assets/images/servIdentity-img.jpg"
// import libImg from "../assets/images/servLib-img.jpg"
// import packageImg from "../assets/images/servPackage-img.jpg"
// import photoImg from "../assets/images/servPhoto-img.jpg"
// import profileImg from "../assets/images/servProfile-img.jpg"
// import socialImg from "../assets/images/servSocial-img.jpg"
// import webImg from "../assets/images/servWeb-img.jpg"

const ServiceData = [
    {
        id: 1,
        title: "المواقع والتطبيقات",
        titleEn: "Web Applications",
        description: "كل مؤسسة يجب أن يكون لديها عنوان على شبكة الإنترنت يبرز نشاطاتها ويتحدث عن أقسامها بكل تفصيل، ولدينا آليات مميزة لتنفيذ موقعك الإلكتروني و تطبيقك ومتجرك بأفضل وأحدث آلية",
        descriptionEn: "Every organization should have an online presence that highlights its activities and details its sections comprehensively. We have unique mechanisms to implement your website, application, and store in the best and most modern way.",
        btnCaption: "طلب عرض سعر",
        btnCaptionEn: "Request a Quote",
        btnLink: "services/servWeb",
        imgSrc: webImg,
        imgAlt: "Web Applications services",
        icon: webIcon,
        status: "active",
    },
    {
        id: 2,
        title: "الكتب",
        titleEn: "Books",
        description: "أفضل ما يمكن أن تتركه علمٌ وهبه الله لك، والكتاب كلمات من نور تضيء لك ولمن حولك بما وهبك الله من علم أو معلومة صادقة تفيد بها من حولك وتكون أفضل أثر لك في الدنيا والآخرة",
        descriptionEn: "The best thing you can leave behind is knowledge granted to you by God. A book is words of light that illuminate for you and those around you with the knowledge or truthful information granted to you by God, benefiting those around you and leaving the best impact in this world and the hereafter.",
        btnCaption: "طلب عرض سعر",
        btnCaptionEn: "Request a Quote",
        btnLink: "services/servBooks",
        imgSrc: bookImg,
        imgAlt: "Books services",
        icon: bookIcon,
        status: "active",

    },
    {
        id: 3,
        title: "سوشيال ميديا",
        titleEn: "Social Media",
        description: "السوشيال ميديا هي لغة العصر في التسويق الإلكتروني وتأثيرها في الإنتشار والوصول إلى العملاء أصبحت شئ أساسي لكل منتج أو فكرة أونشاط، معنا ستجد خطة محددة للنشر والتسويق والوصول لعملاءك وجمهورك المحتمل",
        descriptionEn: "Social media is the language of the era in digital marketing. Its impact on spreading and reaching customers has become essential for every product, idea, or activity. With us, you will find a specific plan for publishing, marketing, and reaching your potential customers and audience.",
        btnCaption: "طلب عرض سعر",
        btnCaptionEn: "Request a Quote",
        btnLink: "services/servSocial",
        imgSrc: socialImg,
        imgAlt: "Social media services",
        icon: socialIcon,
        status: "active",
    },
    {
        id: 4,
        title: "الهوية البصرية",
        titleEn: "Identity",
        description: "الهوية جو عام يمثلك من خلال شعار ومجموعة لونية وأشكال متداخلة أو مبسطة تعبر عنك وتكون عنوان لك يعرفُكَ بها كل متلقٍ لها بتطبيقها على العناصر المختلفة",
        descriptionEn: "Identity is a general atmosphere that represents you through a logo, a set of colors, and intertwined or simplified shapes that express you and serve as your title, recognized by everyone who encounters it when applied to various elements.",
        btnCaption: "طلب عرض سعر",
        btnCaptionEn: "Request a Quote",
        btnLink: "services/servIdentity",
        imgSrc: identityImg,
        imgAlt: "Identity Services",
        icon: identityIcon,
        status: "active",
    },
    {
        id: 5,
        title: "باكج دعائي",
        titleEn: "Advertise",
        description: "تطبيق لهويتك البصرية على أوراقك الرسمية (ورق مكاتبات - فواتير - إذن صرف - إذن استلام - ختم - كروت) حدد المطلوب ويشرفنا التنفيذ",
        descriptionEn: "Applying your visual identity to your official documents (letterheads, invoices, disbursement vouchers, receipt vouchers, stamps, cards). Specify what is needed, and we are honored to execute it.",
        btnCaption: "طلب عرض سعر",
        btnCaptionEn: "Request a Quote",
        btnLink: "services/servAdv",
        imgSrc: advImg,
        imgAlt: "Advertise Services",
        icon: advIcon,
        status: "active",
    },
    {
        id: 6,
        title: "التغليف والعلب",
        titleEn: "Packaging",
        description: "مما لا شك فيه أن التغليف الجيد والمبتكر لمنتجك ينقله إلى مستوى آخر، نحن معك لنساعدك لخروج منتجك بأفضل صورة ممكنة لدينا آليات كاملة لتصميم وطباعة وتنفيذ تغليف بأفكار جديدة رائعة",
        descriptionEn: "There is no doubt that good and innovative packaging for your product takes it to another level. We are here to help you present your product in the best possible way. We have complete mechanisms for designing, printing, and executing packaging with new and wonderful ideas.",
        btnCaption: "طلب عرض سعر",
        btnCaptionEn: "Request a Quote",
        btnLink: "services/servPackage",
        imgSrc: packageImg,
        imgAlt: "Packaging Services",
        icon: packageIcon,
        status: "active",
    },
    {
        id: 7,
        title: "لافتات دعائية",
        titleEn: "Banners",
        description: "يمكننا تنفيذ اللافتات الخارجية بكل أنواعها وأشكالها بما يتنساب مع نشاطك وبأفضل الوسائل والخامات التي تظهرك بشكل مميز ورائع",
        descriptionEn: "We can execute outdoor banners of all types and shapes to suit your activity, using the best methods and materials to present you in a distinctive and wonderful way.",
        btnCaption: "طلب عرض سعر",
        btnCaptionEn: "Request a Quote",
        btnLink: "services/servBanner",
        imgSrc: bannersImg,
        imgAlt: "Banners Services",
        icon: bannersIcon,
        status: "active",
    },
    {
        id: 8,
        title: "التصوير",
        titleEn: "Photography",
        description: "التصوير الجيد من اهم وسائل نجاح ظهور منتجك ومحتواك بشكل مميزلدينا فريق محترف من المصورين والمخرجين ومتخصصين الميديا لخروج محتواك بشكل مميز بداية من تجهيز الإسكربت ومروراً بالسينريو وصولا للتصوير بأحدث الكاميرات والأدوات الخاصة بالتصوير",
        descriptionEn: "Good photography is one of the most important means of successfully showcasing your product and content in a distinctive way. We have a professional team of photographers, directors, and media specialists to present your content in an outstanding manner, starting from script preparation, through the scenario, to shooting with the latest cameras and photography tools.",
        btnCaption: "طلب عرض سعر",
        btnCaptionEn: "Request a Quote",
        btnLink: "services/servPhoto",
        imgSrc: photoImg,
        imgAlt: "Photography Services",
        icon: photoIcon,
        status: "active",
    },
    {
        id: 9,
        title: "تنظيم معارض",
        titleEn: "Exhibitions",
        description: "جناحك في المعرض يمثلك بشكل كامل حيث مشاركتك في المعارض يمثل احتكاك مباشر بالعملاء المحتملين وأقرانك في المجال، لذلك نحن في انتظارك لنبني لك تصور الجناح بداية من تصميم الجناح مودلينج 3D إلى تطبيقه وتنفيذه بكل دقة، من خلال تنفيذ مميز ورائع لما سيتم تصميمه",
        descriptionEn: "Your booth at the exhibition fully represents you, as your participation in exhibitions is direct interaction with potential customers and peers in the field. Therefore, we are waiting to create a vision for your booth, starting from 3D modeling to its precise application and execution, with outstanding and wonderful implementation of the design.",
        btnCaption: "طلب عرض سعر",
        btnCaptionEn: "Request a Quote",
        btnLink: "services/servShows",
        imgSrc: showImg,
        imgAlt: "Shows Services",
        icon: showIcon,
        status: "active",
    },
    {
        id: 10,
        title: "البروفايل",
        titleEn: "Profile",
        description: "بروفايل الشركات: بوابة للإبداع والتميز، حيث تتجسد رؤيتنا وقيمنا. اكتشفوا تاريخنا ومنتجاتنا الابتكارية وشراكاتنا الملهمة لتحقيق النجاح المشترك",
        descriptionEn: "Company profiles: A gateway to creativity and excellence, where our vision and values are embodied. Discover our history, innovative products, and inspiring partnerships to achieve shared success.",
        btnCaption: "طلب عرض سعر",
        btnCaptionEn: "Request a Quote",
        btnLink: "services/servProfile",
        imgSrc: profileImg,
        imgAlt: "Profile Services",
        icon: profileIcon,
        status: "active",
    },
    {
        id: 11,
        title: "مكتبة مسار",
        titleEn: "Masar Library",
        description: "تمثل مكتبة مسار منصة رائعة لخدمة القارئ بكل تنوعات طلباته، حيث توفر لكم كتب كثيرة في مجالات متعددة يمكن طلبها من خلال المنصة، لتصلكم في وقت قياسي وبأي كمية، ونعدكم أن نثري المنصة بكتب مميزة في كل المجالات وأن نكون على عهدنا بتوفيرها لكم بجودة رائعة أينما كنتم",
        descriptionEn: "Masar Library represents a wonderful platform to serve readers with all their diverse requests. It provides you with many books in various fields that can be ordered through the platform, delivered to you promptly and in any quantity. We promise to enrich the platform with distinctive books in all fields and to remain committed to providing them to you with excellent quality wherever you are.",
        btnCaption: "تصفح المكتبة",
        btnCaptionEn: "Browse Library",
        btnLink: "masarLibrary",
        imgSrc: libImg,
        imgAlt: "Masar Library",
        icon: libIcon,
        status: "active",
    }
]

const ServiceCode = `${ServiceData.map(service => service.id)}`

export { ServiceData, ServiceCode };